import { useState } from 'react';
import { useUpdateNominationStatusMutation } from 'store/api/rankingsReferees';
import { NominationStatus } from 'types/efforts';
import { t } from 'utils/getTranslations';
import { NominationStatusSelect } from './NominationStatusSelect';

type Props = {
    id: number;
    value: NominationStatus;
    /** Names the nomination, for the select. */
    label: string;
    /** May change it: the select saves on change. Otherwise the status reads as its word. */
    canUpdate: boolean;
};

/**
 * A stored nomination's status. A change saves at once with no toast of its own, the select being the feedback; a
 * refused save is toasted by the API layer and the select goes back to the stored status.
 */
export function NominationStatusControl({ id, value, label, canUpdate }: Props) {
    const [update] = useUpdateNominationStatusMutation();
    // The choice being saved, shown until the refetch brings it back as `value`.
    const [pending, setPending] = useState<NominationStatus | null>(null);
    if (pending !== null && pending === value) {
        setPending(null);
    }

    if (!canUpdate) {
        return <span>{t(`rankings-referees.status.${value}`)}</span>;
    }
    return (
        <NominationStatusSelect
            value={pending ?? value}
            label={label}
            onChange={(statusCode) => {
                setPending(statusCode);
                update({ id, statusCode })
                    .unwrap()
                    .catch(() => setPending(null));
            }}
        />
    );
}
